/**
 * Products API service
 * Handles all product-related API calls
 * Based on frontend_integration_guide.md
 */

import client from './client'

/**
 * Get products list with pagination and filtering
 * @param {Object} params - Query parameters
 * @param {number} params.page - Page number (default: 1)
 * @param {number} params.pageSize - Items per page (default: 20, max: 100)
 * @param {number} params.application_field_id - Application field ID (optional)
 * @param {string} params.search - Search keyword by product name or model (optional)
 * @returns {Promise<Object>} Response with { code, data: { list, pagination } }
 */
export async function getProducts(params = {}) {
  try {
    const response = await client.get('/products', { params })
    return response.data
  } catch (error) {
    return handleApiError(error)
  }
}

/**
 * Get product detail by ID
 * @param {number} id - Product ID
 * @returns {Promise<Object>} Response with { code, data: { product object } }
 */
export async function getProductById(id) {
  try {
    const response = await client.get(`/products/${id}`)
    return response.data
  } catch (error) {
    return handleApiError(error)
  }
}

/**
 * Handle API errors and return unified response
 * @param {Error} error - Axios error object
 * @returns {Object} Error response with code and message
 */
function handleApiError(error) {
  if (error.response?.data) {
    // API returned error response
    return error.response.data
  }

  // Network or other error
  return {
    code: 0,
    message: error.message || '请求失败，请检查网络连接'
  }
}

export default {
  getProducts,
  getProductById
}
